import { render, staticRenderFns } from "./#comment.vue?vue&type=template&id=4d8bb883&scoped=true&"
import script from "./#comment.vue?vue&type=script&lang=js&"
export * from "./#comment.vue?vue&type=script&lang=js&"
import style0 from "./#comment.vue?vue&type=style&index=0&id=4d8bb883&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8bb883",
  null
  
)

export default component.exports